import { useContext, useEffect, useRef, useState } from 'react'
import PageWrapper from '../layout/PageWrapper/PageWrapper'
import Page from '../layout/Page/Page'
import { useFormik } from 'formik'
import { showLoader, TableLoader } from '../services/loader.services'
import NoDataMsg from '../common/components/NoDataMsg'
import useSortableData from '../hooks/useSortableData'
import { toasts } from '../services/toaste.service'
import PaginationButtons, { dataPagination } from './PaginationButtons'
import Button, { ButtonGroup } from './bootstrap/Button'
import Card, { CardHeader, CardLabel, CardTitle, CardBody, CardActions } from './bootstrap/Card'
import Icon from './icon/Icon'
import Input from './bootstrap/forms/Input'
import { addCity, addCompanyDetails, deleteCompanyDetails, getCompanyDetails, getStatesAndCity, updateCompanyDetails } from '../services/common.service'
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from './bootstrap/Modal';
import FormGroup from './bootstrap/forms/FormGroup'
import Textarea from './bootstrap/forms/Textarea'
import SearchableSelect from '../common/components/SearchableSelect'
import { getLicenseKey } from '../services/application.settings'
import AuthContext from '../contexts/authContext'
import DeleteComponents from '../common/components/DeleteComponents'
import AlertService from '../services/alert.service'
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from './bootstrap/OffCanvas'

const CompnyDetails = () => {

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [companyDetailsData, setCompanyDetailsData] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState<any>('')

    const [currentPage, setCurrentPage] = useState<any>(1);
    const [perPage, setPerPage] = useState<any>(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(companyDetailsData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [dataStatus, setDataStatus] = useState<any>(false);
    const [addCompanyOffCanvas, setAddCompanyOffCanvas] = useState<any>(false)
    const [isDeleteOpen, setIsDeleteOpen] = useState<any>(false)

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState<any>(false);

    const [statesData, setStatesData] = useState<any>([]);
    const [cityData, setCityData] = useState<any>([]);

    const [stateId, setStateId] = useState<any>({ value: 31, label: 'Tamil Nadu' });
    const [cityId, setCityId] = useState<any>([]);

    const [isCityModalOpen, setIsCityModalOpen] = useState<any>(false);

    const [companyDetailsId, setCompanyDetailsId] = useState<any>('');
    const pendingCityName = useRef<string | null>(null);

    useEffect(() => {
        getCompanyList()
        getStates()
    }, [])

    const columnVisibileForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },
        onSubmit: () => { },
    });

    // Filter
    const filteredData: any = onCurrentPageData.filter(
        (i) =>
            (i.sno && i.sno.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.companyName && i.companyName.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.address && i.address.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.stateName && i.stateName.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.cityName && i.cityName.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.pincode && i.pincode.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase()))
    );

    function getCompanyList() {
        setDataStatus(false)
        getCompanyDetails(0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.companyDetails;
                    if (data != undefined) {
                        setCompanyDetailsData(data)
                        setDataStatus(true)
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                        }
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setCompanyDetailsData([])
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }



    function getStates() {
        getStatesAndCity(0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.statesAndCity;
                    if (data != undefined) {
                        setStatesData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setStatesData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function selectState(stateId: any) {
        if (stateId?.value != undefined) {
            getCitys(stateId?.value)
            setStateId(stateId)
        } else {
            setStateId('');
            setCityData([]);
            setCityId('');
        }
    }

    function selectCity(cityId: any) {
        if (cityId?.value != undefined) {
            setCityId(cityId)
        } else {
            setCityId('')
        }
    }

    function getCitys(stateId: any) {
        getStatesAndCity(stateId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.statesAndCity[0].city;
                    if (data != undefined) {
                        setCityData(data)
                        if (pendingCityName.current) {
                            const newCity = data.find((c: any) => c.cityName === pendingCityName.current);
                            if (newCity) {
                                setCityId({ value: newCity.cityId, label: newCity.cityName });
                            }
                            pendingCityName.current = null;
                        }
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setCityData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    const companyForm = useFormik({
        enableReinitialize: true,
        validateOnMount: true,
        initialValues: {
            companyName: '',
            address: '',
            stateId: '',
            cityId: '',
            pincode: '',
            gstNo: '',
            panNo: '',
        },
        validate: (values) => {
            const errors: {
                companyName?: string;
                address?: string;
                stateId?: string;
                cityId?: string;
                pincode?: string;
            } = {};
            if (!values.companyName) {
                errors.companyName = 'Required';
            }
            if (!values.address) {
                errors.address = 'Required';
            }
            if (!stateId || !stateId.value) {
                errors.stateId = 'Required';
            }
            if (!cityId || !cityId.value) {
                errors.cityId = 'Required';
            }
            if (!values.pincode) {
                errors.pincode = 'Required';
            } else if (!/^\d{6}$/.test(values.pincode)) {
                errors.pincode = 'Invalid pincode (6 digits required)';
            }
            return errors;
        },

        //validateOnChange: false,
        onSubmit: () => { companyDetailsId > 0 ? updateCompanyDetailsSubmit() : addCompanyDetailsSubmit() },
    });

    const cityForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            cityCode: '',
            cityName: '',
        },
        validate: (values) => {
            const errors: {
                cityCode?: string;
                cityName?: string;
            } = {};
            if (!values.cityCode) {
                errors.cityCode = 'Required';
            }
            if (!values.cityName) {
                errors.cityName = 'Required';
            }
            return errors;
        },
        onSubmit: () => { addCitySubmit() },
    });

    function addCitySubmit() {
        showLoader(true)
        if (cityForm.isValid) {
            let cityPostData = {
                licenseKey: getLicenseKey,
                stateId: stateId?.value,
                cityCode: cityForm.values.cityCode,
                cityName: cityForm.values.cityName,
                userAccountId: userAccountId
            }
            addCity(cityPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        setIsCityModalOpen(false);
                        pendingCityName.current = cityForm.values.cityName;
                        cityForm.resetForm();
                        getCitys(stateId?.value);
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }
                , (error) => {
                    showLoader(false)
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        } else {
            showLoader(false)
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
        }
    }

    function onActivate(i: any) {
        if (i != undefined) {
            let selectedCompany = i
            setAddCompanyOffCanvas(true)
            setCompanyDetailsId(selectedCompany?.companyDetailsId)
            setStateId({ value: selectedCompany?.stateId, label: selectedCompany?.stateName });
            setCityId({ value: selectedCompany?.cityId, label: selectedCompany.cityName });
            companyForm.setValues({
                companyName: selectedCompany?.companyName,
                address: selectedCompany?.address,
                stateId: selectedCompany?.stateId,
                cityId: selectedCompany?.cityId,
                pincode: selectedCompany?.pincode,
                gstNo: selectedCompany?.gstNo,
                panNo: selectedCompany?.panNo
            })
            getCitys(selectedCompany?.stateId);
        }
    }

    function setCompany() {
        return ({
            licenseKey: getLicenseKey,
            companyName: companyForm.values.companyName,
            address: companyForm.values.address,
            stateId: stateId?.value,
            cityId: cityId?.value,
            pincode: companyForm.values.pincode,
            gstNo: companyForm.values.gstNo,
            panNo: companyForm.values.panNo,
            userAccountId: userAccountId
        })
    }

    function setEditCompany() {
        return ({
            licenseKey: getLicenseKey,
            companyDetailsId: companyDetailsId,
            companyName: companyForm.values.companyName,
            address: companyForm.values.address,
            stateId: stateId?.value,
            cityId: cityId?.value,
            pincode: companyForm.values.pincode,
            gstNo: companyForm.values.gstNo,
            panNo: companyForm.values.panNo,
            userAccountId: userAccountId
        })
    }

    function addCompanyDetailsSubmit() {
        showLoader(true)
        if (companyForm.isValid) {
            let companyPostData = setCompany();
            addCompanyDetails(companyPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        setAddCompanyOffCanvas(false);
                        closeAndReset();
                        getCompanyList();
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }
                , (error) => {
                    showLoader(false)
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        } else if (companyForm.isValid == false) {
            showLoader(false)
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
        }
    }

    function updateCompanyDetailsSubmit() {
        showLoader(true)
        if (companyForm.isValid) {
            let companyPostData = setEditCompany();
            updateCompanyDetails(companyPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        setAddCompanyOffCanvas(false);
                        closeAndReset();
                        getCompanyList();
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }
                , (error) => {
                    showLoader(false)
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        } else if (companyForm.isValid == false) {
            showLoader(false)
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
        }
    }

    function deleteCompanyDetailsSubmit() {
        showLoader(true)
        if (companyDetailsId > 0) {
            let companyPostData = setEditCompany();
            deleteCompanyDetails(companyPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        setAddCompanyOffCanvas(false);
                        closeAndReset();
                        getCompanyList();
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }
                , (error) => {
                    showLoader(false)
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        } else if (companyDetailsId == 0) {
            showLoader(false)
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
        }
    }

    function closeAndReset() {
        companyForm.resetForm();
        setStateId('');
        setCityId('');
        setCompanyDetailsId('');
        setAddCompanyOffCanvas(false);
    }

    function openAddModal() {
        companyForm.resetForm();
        setStateId('');
        setCityId('');
        setCompanyDetailsId('');
        setAddCompanyOffCanvas(true)
    }

    return (
        <PageWrapper title={`Company List`}>
            <Page>
                <Card stretch data-tour='list'>
                    <CardHeader borderSize={1}>
                        <CardLabel icon='Place' iconColor='info' className="col-lg-7">
                            <CardTitle tag='div' className='h5'>Company List</CardTitle>
                        </CardLabel>

                        <CardActions>
                            <ButtonGroup className="d-print-none" color='primary'>
                                <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                                <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibileForm.handleChange} value={columnVisibileForm.values.searchInput} />
                            </ButtonGroup>

                            <Button color='primary' icon="Add" onClick={openAddModal}>
                                Add New
                            </Button>
                        </CardActions>
                    </CardHeader>
                    <CardBody>
                        {!dataStatus ?
                            <TableLoader /> :
                            <div className="table-responsive">
                                <table className='table table-modern table-hover small'>
                                    <thead className='table-primary'>
                                        <tr>
                                            <th scope='col' onClick={() => requestSort('sno')} className='cursor-pointer py-3 border-bottom-0 bg-light rounded-start'>
                                                <span className='small text-uppercase fw-bold'>S.no</span>
                                                <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('companyName')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Company</span>
                                                <Icon size='lg' className={getClassNamesFor('companyName')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('address')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Address</span>
                                                <Icon size='lg' className={getClassNamesFor('address')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('stateName')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>State & City</span>
                                                <Icon size='lg' className={getClassNamesFor('stateName')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('pincode')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Pincode</span>
                                                <Icon size='lg' className={getClassNamesFor('pincode')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('gstNo')} className='cursor-pointer py-3 border-bottom-0 bg-light text-center'>
                                                <span className='small text-uppercase fw-bold'>GST IN</span>
                                                <Icon size='lg' className={getClassNamesFor('gstNo')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('panNo')} className='cursor-pointer py-3 border-bottom-0 bg-light text-center'>
                                                <span className='small text-uppercase fw-bold'>PAN</span>
                                                <Icon size='lg' className={getClassNamesFor('panNo')} icon='FilterList' />
                                            </th>
                                            <th className='text-center py-3 border-bottom-0 bg-light rounded-end'>
                                                <span className='small text-uppercase fw-bold'>Action</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    {filteredData != "" ? (
                                        filteredData.map((item: any) => (
                                            <tbody key={item.companyDetailsId} className='border-top-0'>
                                                <tr className='shadow-hover-sm transition-base'>
                                                    <td className='py-3 fw-bold text-muted'>{item.sno}</td>
                                                    <td className='py-3' style={{ width: "250px" }}>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='flex-grow-1 ms-3'>
                                                                <div className='fw-bold text-dark'>{item.companyName}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className='py-3' style={{ width: "250px" }}>
                                                        <div className='text-muted small'>
                                                            {item.address}
                                                        </div>
                                                    </td>
                                                    <td className='py-3'>
                                                        <div className='fw-semibold text-dark'>{item.cityName}</div>
                                                        <div className='text-muted small'>{item.stateName}</div>
                                                    </td>
                                                    <td className='py-3 text-dark'>{item.pincode}</td>
                                                    <td className={`py-3 ${item.gstNo ? '' : 'text-center'}`}>
                                                        {item.gstNo ? (
                                                            <span className='badge bg-l10-primary text-primary px-2 py-1 rounded-pill small fw-bold'>
                                                                {item.gstNo}
                                                            </span>
                                                        ) : (
                                                            <span className='text-muted'>-</span>
                                                        )}
                                                    </td>
                                                    <td className={`py-3 ${item.panNo ? '' : 'text-center'}`}>
                                                        {item.panNo ? (
                                                            <span className='badge bg-l10-success text-success px-2 py-1 rounded-pill small fw-bold'>
                                                                {item.panNo}
                                                            </span>
                                                        ) : (
                                                            <span className='text-muted'>-</span>
                                                        )}
                                                    </td>
                                                    <td className='py-3 text-center d-print-none'>
                                                        <Button
                                                            color='primary'
                                                            isLight
                                                            icon='Edit'
                                                            className='rounded-pill'
                                                            onClick={() => onActivate(item)}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ))
                                    ) : (
                                        <NoDataMsg columnsCount={8} msg={noDataMsg || 'No data found'} />
                                    )}
                                </table>
                            </div>
                        }
                    </CardBody>
                    <PaginationButtons className="d-print-none" data={items} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
                </Card>


                <OffCanvas
                    setOpen={setAddCompanyOffCanvas}
                    isOpen={addCompanyOffCanvas}
                    titleId='addCompanyOffCanvas'
                    isBodyScroll
                    isBackdrop
                    isStaticBackdrop
                >
                    <OffCanvasHeader onClick={closeAndReset}>
                        <OffCanvasTitle id='addCompanyOffCanvas'>{companyDetailsId > 0 ? 'Update Company Details' : 'Add Company Details'}</OffCanvasTitle>
                    </OffCanvasHeader>
                    <OffCanvasBody>
                        <div className="row g-4">
                            <div className='col-lg-12'>
                                <FormGroup id='companyName' label='Company Name'>
                                    <Input
                                        onChange={companyForm.handleChange}
                                        value={companyForm.values.companyName}
                                        onBlur={companyForm.handleBlur}
                                        isValid={companyForm.touched.companyName ? !companyForm.errors.companyName : undefined}
                                        isTouched={companyForm.touched.companyName}
                                        invalidFeedback={companyForm.errors.companyName}
                                        placeholder="Enter Company Name"
                                        type='text' />
                                </FormGroup>
                            </div>
                            <div className='col-lg-12'>
                                <FormGroup id='address' label='Address'>
                                    <Textarea
                                        onChange={companyForm.handleChange}
                                        value={companyForm.values.address}
                                        onBlur={companyForm.handleBlur}
                                        isValid={companyForm.touched.address ? !companyForm.errors.address : undefined}
                                        isTouched={companyForm.touched.address}
                                        invalidFeedback={companyForm.errors.address}
                                        placeholder="Enter Address" />
                                </FormGroup>
                            </div>
                            <div className='col-md-12'>
                                <FormGroup id='stateId' label='State'>
                                    <div onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                        <SearchableSelect
                                            ariaLabel='State'
                                            onChange={selectState}
                                            value={stateId}
                                            onBlur={() => companyForm.setFieldTouched('stateId', true)}
                                            isValid={companyForm.touched.stateId ? !companyForm.errors.stateId : undefined}
                                            isTouched={companyForm.touched.stateId}
                                            invalidFeedback={companyForm.errors.stateId}
                                            list={statesData.map((data: any) => ({
                                                value: data.stateId,
                                                label: data.stateName,
                                            }))}
                                            required
                                        />
                                    </div>
                                </FormGroup>
                            </div>
                            <div className="col-lg-12">
                                <FormGroup id="cityId" label="City">
                                    <div onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                        <SearchableSelect ariaLabel="" placeholder="Select City"
                                            onChange={selectCity}
                                            value={cityId}
                                            list={cityData.map((data: any) => (
                                                { value: data.cityId, label: data.cityName }
                                            ))}
                                            onBlur={() => companyForm.setFieldTouched('cityId', true)}
                                            isValid={companyForm.touched.cityId ? !companyForm.errors.cityId : undefined}
                                            isTouched={companyForm.touched.cityId}
                                            invalidFeedback={companyForm.errors.cityId}
                                            noOptionsMessage={({ inputValue }: { inputValue: string }) => (
                                                <div className="d-flex flex-column align-items-center">
                                                    <div className="mb-2">No Data available</div>
                                                    {stateId && stateId.value && (
                                                        <Button
                                                            color="primary"
                                                            isLight
                                                            size="sm"
                                                            onMouseDown={(e: any) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                cityForm.setFieldValue('cityName', inputValue);
                                                                setIsCityModalOpen(true);
                                                            }}
                                                        >
                                                            Add New City
                                                        </Button>
                                                    )}
                                                </div>
                                            )}
                                        />
                                    </div>
                                </FormGroup>
                            </div>
                            <div className='col-lg-12'>
                                <FormGroup id='pincode' label='Pincode'>
                                    <Input
                                        onChange={(e: any) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            if (val.length <= 6) {
                                                companyForm.setFieldValue('pincode', val);
                                            }
                                        }}
                                        value={companyForm.values.pincode}
                                        onBlur={companyForm.handleBlur}
                                        isValid={companyForm.touched.pincode ? !companyForm.errors.pincode : undefined}
                                        isTouched={companyForm.touched.pincode}
                                        invalidFeedback={companyForm.errors.pincode}
                                        placeholder="Enter Pincode"
                                        type='text' />
                                </FormGroup>
                            </div>
                            <div className='col-lg-12'>
                                <FormGroup id='gstNo' label='GST IN'>
                                    <Input
                                        onChange={companyForm.handleChange}
                                        value={companyForm.values.gstNo}
                                        onBlur={companyForm.handleBlur}
                                        placeholder="Enter GST IN"
                                        type='text' />
                                </FormGroup>
                            </div>
                            <div className='col-lg-12'>
                                <FormGroup id='panNo' label='PAN'>
                                    <Input
                                        onChange={companyForm.handleChange}
                                        value={companyForm.values.panNo}
                                        onBlur={companyForm.handleBlur}
                                        placeholder="Enter PAN"
                                        type='text' />
                                </FormGroup>
                            </div>
                        </div>
                    </OffCanvasBody>
                    {companyDetailsId > 0 ?
                        <div className='row m-0'>
                            <div className="d-flex justify-content-center position-absolute top-65 start-50 translate-middle">
                                <DeleteComponents isDeleteOpen={isDeleteOpen} setIsDeleteOpen={setIsDeleteOpen} delectFunction={deleteCompanyDetailsSubmit} />
                            </div>
                            <div className='col-6 p-3'>
                                <Button color='danger' className='w-100' icon="Delete" onClick={() => setIsDeleteOpen(!isDeleteOpen)}>
                                    Delete
                                </Button>
                            </div>
                            <div className='col-6 p-3'>
                                <Button color='info' icon="Save" className='w-100' type="submit" isDisable={!companyForm.isValid} onClick={companyForm.handleSubmit}> Update</Button>
                            </div>
                        </div> :
                        <div className='row m-0'>
                            <div className='col-12 p-3'>
                                <Button color='info' icon="Save" className='w-100' type="submit" isDisable={!companyForm.isValid} onClick={companyForm.handleSubmit}>
                                    Save
                                </Button>
                            </div>
                        </div>
                    }
                </OffCanvas>

                <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />

                <Modal isOpen={isCityModalOpen} setIsOpen={setIsCityModalOpen} isCentered>
                    <ModalHeader setIsOpen={setIsCityModalOpen}>
                        <ModalTitle id="addCityModalTitle">Add New City</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row g-3">
                            <div className="col-12">
                                <FormGroup id="cityCode" label="City Code" isFloating>
                                    <Input
                                        onChange={cityForm.handleChange}
                                        value={cityForm.values.cityCode}
                                        onBlur={cityForm.handleBlur}
                                        isValid={cityForm.isValid}
                                        isTouched={cityForm.touched.cityCode}
                                        invalidFeedback={cityForm.errors.cityCode}
                                        placeholder="Enter City Code"
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-12">
                                <FormGroup id="cityName" label="City Name" isFloating>
                                    <Input
                                        onChange={cityForm.handleChange}
                                        value={cityForm.values.cityName}
                                        onBlur={cityForm.handleBlur}
                                        isValid={cityForm.isValid}
                                        isTouched={cityForm.touched.cityName}
                                        invalidFeedback={cityForm.errors.cityName}
                                        placeholder="Enter City Name"
                                    />
                                </FormGroup>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" icon="Save" className="w-100" onClick={cityForm.handleSubmit}>
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>

            </Page>
        </PageWrapper >
    )
}

export default CompnyDetails;